import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-611d8458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "servicesFrontCard" }
const _hoisted_2 = { class: "servicesFrontCard__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "servicesFrontCard__line" }, null, -1))
const _hoisted_4 = { class: "servicesFrontCard__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.serviceData.name), 1),
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.serviceData.front), 1)
  ]))
}